var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('v-container', {
    staticClass: "container--large"
  }, [_c('main-visual', {
    attrs: {
      "code": "expo-program-pc",
      "pc": ""
    }
  }), _c('main-visual', {
    attrs: {
      "code": "expo-program-mobile",
      "mobile": ""
    }
  })], 1), _c('section', {
    staticClass: "section"
  }, [_c('v-container', {
    staticClass: "container--large"
  }, [_c('expo-program-list-filter', _vm._b({
    staticClass: "mb-10 mb-md-20 mb-lg-28"
  }, 'expo-program-list-filter', {
    loading: _vm.loading
  }, false)), _vm.items.length ? [_c('v-row', {
    staticClass: "my-n10 my-lg-n20"
  }, [_vm._l(_vm.items, function (item) {
    return [_c('v-col', {
      key: item._id,
      staticClass: "py-10 py-lg-20",
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "3"
      }
    }, [_c('expo-program-item', {
      attrs: {
        "value": item
      }
    })], 1)];
  })], 2), _c('div', {
    staticClass: "mt-40 mt-lg-60"
  }, [_c('v-pagination', {
    staticClass: "my-16",
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function (page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page
          })
        });
      }
    }
  })], 1)] : [_c('v-layout', {
    staticClass: "page-text page-text--lg border-top pt-12 pt-lg-20",
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_vm._v(" 등록된 프로그램이 없습니다. ")])]], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }